import React, { Component } from "react";
import { Link } from "react-router-dom";
import favicon from "../assets/favicon.ico";

export default class home extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="text-center container">
          <hr className="welcome_hr" />
          <span className="welcome_text">
            <img src={favicon} alt="holdingHands" /> &nbsp;&nbsp;&nbsp; Welcome to UGA helper &nbsp;&nbsp;&nbsp;
            <img src={favicon} alt="holdingHands" />
          </span>
          <hr className="welcome_hr" />
        </div>
        <section className="container">
          This website will help you with your doubts regarding pre and post admission requirements at UGA specifically for MS in CS.
          However, many topics covered here will be applicable to all streams.
          <br />
          <br />
          {/* <div>
            If you are applying at UGA and would like to know about the requirements - <Link to={"/preAdmission"}>visit here</Link>
          </div> */}
          <br />
          <div>
            If you have received an offer letter and would like to know about the next steps -<Link to={"/postAdmission"}>visit here</Link>
          </div>
          <hr />
        </section>
        <section className="container">
          <Link to={"/"} className="section_head">
            PRE Admission
          </Link>
          <br />
          Before you begin with the process, make sure to create a seperate gmail account as it will avoid clutter in your inbox and this
          email will be used for all communication with the university
          <br />
          <br />
          <div>
            To apply to graduate school use this link: &nbsp;&nbsp;&nbsp;
            <a
              href="https://grad.uga.edu/index.php/prospective-students/apply-now/"
              target={"_blank"}
              rel={"noreferrer"}
              className="redLink"
            >
              Application Link
            </a>
            &nbsp;&nbsp; &nbsp; and click on <span style={{ fontStyle: "italic", fontWeight: "bold" }}>start your application</span> to
            begin application.
          </div>
          <div>
            To know about the requirements you can use this link: &nbsp;&nbsp;
            <a
              href="http://grad.uga.edu/index.php/prospective-students/international-application-information/"
              target={"_blank"}
              rel={"noreferrer"}
              className="redLink"
            >
              Requirements
            </a>
          </div>
          The application Deadlines can be found here &nbsp;&nbsp;
          <a href="https://www.cs.uga.edu/graduate-admissions" target={"_blank"} rel={"noreferrer"} className="redLink">
            application deadline
          </a>
          <br />
          The deadline to accept the application and provide all necessary documents can be found here: &nbsp;&nbsp;
          <a
            href="http://grad.uga.edu/index.php/prospective-students/domestic-application-information/application-deadlines/"
            target={"_blank"}
            rel={"noreferrer"}
            className="redLink"
          >
            Admission acceptance deadline
          </a>
          <br />
          {/* For more details:{" "}
          <div className="btn btn-link">
            <Link to={"/preAdmission"}>Pre Admission details full</Link>
          </div> */}
          <hr />
        </section>
        <section className="container">
          <Link to={"/postAdmission"} className="section_head">
            POST Admission
          </Link>
          <br />
          Once you get the admission you will have to accept the offer letter to proceed further. <br />
          Then you will find that you have certain things to complete on the checklist - these to-dos will affect your registration. They
          are holds and you need to clear them to register for classes.
          <br />
          <br />
          <div className="container-fluid">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Transcript
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <strong>You need to send the Transcripts to the university.</strong>&nbsp;&nbsp; You may have already submitted the
                    unofficial transcript. The university needs you to submit the official transcript to the university via post. Official
                    transcripts may be mailed to the university from your school, mailed to the university by you, or else brought to the
                    university in person. Official transcripts must remain sealed in the issuing institution's envelope to be considered
                    official. You may also need to provide your degree certificate (
                    <i>You can inquire about this after your transcripts are submitted</i>)
                    <br />
                    You can find more details here:{" "}
                    <a
                      href="http://grad.uga.edu/index.php/prospective-students/domestic-application-information/requirements/transcripts-and-academic-records/"
                      target={"_blank"}
                      rel={"noreferrer"}
                      style={{ textDecoration: "underline" }}
                      className="redLink"
                    >
                      Transcript details
                    </a>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Immunization
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <strong>This is the second hold that you need to clear</strong>
                    The university needs to see your immunization records which includes the list of vaccines that are required before
                    enrolling. You might also need to do TB testing depending. You can find more details and list of required vaccinations
                    here:{" "}
                    <a href="https://healthcenter.uga.edu/info/immunizations/" target={"_blank"} rel={"noreferrer"} className="redLink">
                      Immunization requirements
                    </a>
                    <br />
                    <br />
                    If you want a more detailed article with all steps check here:{" "}
                    <Link to={"/postAdmission/immunization"} className="redLink">
                      Immunization detailed
                    </Link>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    I20
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <strong>
                      This is the form you have to submit to show that you have the financial backing to attend the university
                    </strong>
                    <br />
                    You may have received emails from{" "}
                    <b>
                      UGA Immigration <i>(immigration@uga.edu)</i>
                    </b>
                    <br />
                    Click on this link to know about the I20 process in detail -{" "}
                    <Link to={"/postAdmission/I20_process"} className="redLink">
                      I20 process
                    </Link>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Registration Holds
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <strong>Take a look at the holds that you need to clear before you register for classes</strong>
                    <br />
                    <br />
                    Visit this page to know more{" "}
                    <Link to={"/postAdmission/registration_holds"} className="redLink">
                      Registration Hold
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          To know about all the post Admission process in detail visit this link:{" "}
          <Link to={"/postAdmission"}>Post Admission details full</Link>.
          <br />
          <br />
        </section>
      </React.Fragment>
    );
  }
}
